class TC_Player {
    constructor (systemMessages, remoteData, timetableCache) {
        this.remoteData = remoteData;
        this.timetableCache = timetableCache;
        this.user = {
            id: null,
            login: null,
            token: null,
            isVip: false
        };
        this.previousChannelID = 0;
        this.currentChannelUrl = '';
        this.currentChannelStreamUrl = '';
        this.currentChannel = {
            id: 0,
            url: '',
            streamID: null,
            streamUrl: '',
            channelName: '',
            album: '',
            artist: '',
            title: '',
            cover: ''
        };
        this.stalledChannels = {
            channel1: false
        };
        this.stoppedChannelsUserStatus = null;
        this.stoppedChannelsBitrate = null;
        this.setAudioChannels();
        this.channelFromUrl = this.getChannelFromUrl();
        this.currentTrackID = 0;
        this.cursorMoved = false;
        this.systemMessages = systemMessages;
        this.playing = false;
        this.artsUrl = 'https://arts.' + window.CSITE.appDomain;
        this.mainWrapper = false;
        this.sleepTimeout = false;
        this.freePlaybackNotificationTimeout = false;
        this.sleepMode = false;
        this.bitrateMode = this.getBitrate();
        this.introTimeout = false;
        this.useAlernativeVipChannel = false;
        this.mutedAutoplay = true;
        this.pauseEventToSkip = false;
        this.streamIsPaused = false;

        if ($('.cr-player').length) {
            $(document.body).addClass('player-loaded');
            this.channels = null;
        }

        this.debouncedSaveLastListenedChapter = debounce(() => {
            let chaptersData = this.timetableCache.getTimetable(this.currentChannel.streamID, false);
    
            if (chaptersData === false) {
                return;
            }
    
            let chapterNumber = this.detectChapterIndex(chaptersData) + 1;
            let channelID = parseInt(this.currentChannel.id, 10);
            this.remoteData.lastListenedChapters[channelID] = chapterNumber;
            this.updateExpandedItemsUI(channelID, chapterNumber);
            this.updateChaptersUI(false, chapterNumber);
            
            $.post('https://api.' + window.CSITE.appDomain + '/v2/chapter', JSON.stringify({
                username: this.user.login,
                token: this.user.token,
                channel_id: channelID,
                chapter: chapterNumber
            })).done(() => {});
        }, 1000);
    }

    initPlayer () {
        this.checkAutoPlay();
        this.share = new TC_PlayerShare(this);
        this.sleep = new TC_PlayerSleep(this);
        this.bitrate = new TC_PlayerBitrate(this);
        this.freePlayback = new TC_PlayerFreeplayback(this);
        this.cover = new TC_PlayerCover(this);
        this.getUserData();
        this.initEvents();
        this.initVolumeSlider();
    }

    isProbablyMobile() {
        return (
            navigator.userAgent.match(/iPhone/i) ||
            navigator.userAgent.match(/iPad/i) ||
            navigator.userAgent.match(/iPod/i) ||
            navigator.userAgent.match(/Android/i)
        );
    }

    checkAutoPlay () {
        let audioTest = document.querySelector('audio').play();

        if (audioTest !== undefined) {
            audioTest.then(_ => {
                this.mutedAutoplay = false;
            }).catch(err => {
                this.mutedAutoplay = true;
            });
        } else {
            this.mutedAutoplay = false;
        }

        setTimeout(() => {
            $(this.audioChannels.channel1.element).one('play', () => {
                setTimeout(() => {
                    this.playing = true;
                    this.UI.buttons.play.removeClass('is-loading');
                    this.UI.buttons.playIconPause.removeClass('is-hidden');
                    this.UI.buttons.playIconPlay.addClass('is-hidden');
                }, 200);
            });
        }, 500);
    }

    setAudioChannels () {
        this.audioChannels = {
            channel1: {
                element: $('.cr-player-audio-channel-1')[0],
                volume: this.getVolumeConfig()
            }
        };
    }

    getVolumeConfig () {
        let config = localStorage.getItem('calmchristian-player-config');

        if (config) {
            try {
                config = JSON.parse(config);
                let volume = config.channels.channel1.volume || 50;
                return volume / 100;
            } catch (e) {
                console.warn('An error occurred during loading the configuration. Using default value');
                console.log(e);
            }
        }

        return 0.5;
    }

    getBitrate () {
        let config = localStorage.getItem('calmchristian-player-config');

        if (!this.user.isVip) {
            return 192;
        }

        if (config) {
            try {
                config = JSON.parse(config);
                return parseInt(config.bitrate, 10);
            } catch (e) {
                console.warn('An error occurred during loading the configuration. Using default value');
                console.log(e);
                return 192;
            }

            return;
        }

        return 192;
    }

    getUserData () {
        this.user.id = parseInt(document.body.getAttribute('data-current-id'), 10);
        this.user.login = Cookies.get('ice-login');
        this.user.token = Cookies.get('ice-token');
        this.user.isVip = !!parseInt(Cookies.get('ice-vip'), 10);
    }

    initEvents () {
        this.wrapper = $('.cr-player');
        this.mainWrapper = $('.heading-frontpage');
        this.setUI();
        this.UI.album.cover.on('load', () => { this.UI.album.coverWrapper.addClass('is-visible'); });
        this.addUiEvents();
        this.addCommunicationEvents();
        this.initBugSnagReporting();
        this.initSeekingBarEvents();

        $(document).on('channelsAllDataLoaded', () => { this.startPlaying(); });
        $(document).on('channelsLoadError', () => { this.showLoadError(); });
        $(document).on('fullscreenchange', () => { 
            if (document.fullscreenElement) {
                $('.heading-frontpage').addClass('is-fullscreen');
            } else {
                $('.heading-frontpage').removeClass('is-fullscreen');
            }
        });

        $(this.audioChannels.channel1.element).on('play', () => {
            if (this.streamIsPaused && this.streamIsPaused === this.currentChannel.streamID) {
                this.UI.buttons.play.trigger('click');
                this.streamIsPaused = false;
                return;
            } 
            
            if (this.streamIsPaused !== this.currentChannel.streamID) {
                this.streamIsPaused = false;
            }

            this.channels.segmentIntegration.sendApiEvent('Audio Playback Started', 1, 'play');
            this.UI.buttons.playIconPause.removeClass('is-hidden');
            this.UI.buttons.playIconPlay.addClass('is-hidden');
            this.playing = true;
            $(document).trigger('playingStateChanged', [this.playing]);
        });

        $(this.audioChannels.channel1.element).on('pause', () => {
            if (!this.currentChannelHasChapters()) {
                this.streamIsPaused = this.currentChannel.streamID;
            }

            if (!this.pauseEventToSkip) {
                this.channels.segmentIntegration.sendApiEvent('Audio Playback Completed', 1, 'pause');
                this.UI.buttons.playIconPause.addClass('is-hidden');
                this.UI.buttons.playIconPlay.removeClass('is-hidden');
                this.playing = false;
                $(document).trigger('playingStateChanged', [this.playing]);
            } else {
                setTimeout(() => {
                    this.pauseEventToSkip = false;
                }, 200);
            }
        });
    }

    initVolumeSlider () {
        $('.cr-player-volume-slider').rangeslider({
            polyfill: false,
            onSlide: (position, value) => {
                if (parseInt(this.audioChannels.channel1.volume * 100, 10) !== value) {
                    this.setVolume(value);
                }
            },
            onSlideEnd: (position, value) => {
                if (parseInt(this.audioChannels.channel1.volume * 100, 10) !== value) {
                    this.setVolume(value);
                }
            }
        });

        $('.cr-player-volume-slider').val(parseInt(this.audioChannels.channel1.volume * 100, 10)).change();
    }

    setVolume (value) {
        this.audioChannels.channel1.element.volume = value / 100.0;
        this.audioChannels.channel1.volume = value / 100.0;
        window.TC_debouncedPlayerConfigSave(this);
    }

    setUI () {
        this.UI = {
            album: {
                wrapper: this.wrapper.find('.cr-player-album'),
                info: {
                    channelName: $('.cr-player-album-info-channelname'),
                    title: $('.cr-player-album-info-title'),
                    chapters: $('.cr-player-album-info-chapters')
                },
                cover: this.wrapper.find('.cr-player-album-cover-image'),
                coverReplacement: this.wrapper.find('.cr-player-album-cover-image-replacement'),
                coverWrapper: this.wrapper.find('.cr-player-album-cover'),
                addToFav: this.wrapper.find('.cr-player-album-fav'),
                like: this.wrapper.find('.cr-player-album-like'),
                dislike: this.wrapper.find('.cr-player-album-dislike'),
                loader: this.wrapper.find('.cr-player-album-loader')
            },
            buttons: {
                play: this.wrapper.find('.cr-player-play'),
                playIconPlay: this.wrapper.find('.cr-player-play-icon-play'),
                playIconPause: this.wrapper.find('.cr-player-play-icon-pause'),
                switchNext: this.wrapper.find('.cr-player-switch-next'),
                switchPrev: this.wrapper.find('.cr-player-switch-prev'),
                share: this.wrapper.parent().find('.cr-player-share'),
                shareItems: this.wrapper.parent().find('.cr-player-share-item'),
                sleep: this.wrapper.parent().find('.cr-player-sleep'),
                sleepItems: this.wrapper.parent().find('.cr-player-sleep-item'),
                bitrate: this.wrapper.parent().find('.cr-player-bitrate'),
                bitrateItems: this.wrapper.parent().find('.cr-player-bitrate-item'),
                fullscreen: this.wrapper.parent().find('.cr-player-fullscreen')
            },
            popups: {
                share: this.wrapper.parent().find('.cr-player-share-popup'),
                sleep: this.wrapper.parent().find('.cr-player-sleep-popup'),
                bitrate: this.wrapper.parent().find('.cr-player-bitrate-popup')
            },
            loadingError: {
                overlay: this.mainWrapper.find('.cr-player-loading-error'),
                btn: this.mainWrapper.find('.cr-player-loading-error-btn')
            },
            seekingBar: {
                bar: this.mainWrapper.find('.cr-player-seeking-bar'),
                progressBar: this.mainWrapper.find('.cr-player-seeking-bar-progress')
            }
        };
    }

    addUiEvents () {
        this.UI.buttons.play.on('click', () => {
            let playerIsPaused = this.audioChannels['channel1'].element.paused;
            this.eventPlay(playerIsPaused);
        });

        this.UI.buttons.share.on('mouseenter', e => { this.share.eventShare(e); });
        this.UI.buttons.share.on('mouseleave', () => { this.share.hidePopup(); });
        this.UI.popups.share.on('mouseenter', () => { this.share.showPopup(); });
        this.UI.popups.share.on('mouseleave', () => { this.share.hidePopup(); });
        this.UI.popups.share.on('click', e => { e.stopPropagation(); });
        
        this.UI.buttons.sleep.on('mouseenter', e => { this.sleep.eventSleep(e); });
        this.UI.buttons.sleep.on('mouseleave', () => { this.sleep.hidePopup(); });
        this.UI.popups.sleep.on('mouseenter', () => { this.sleep.showPopup(); });
        this.UI.popups.sleep.on('mouseleave', () => { this.sleep.hidePopup(); });
        this.UI.popups.sleep.on('click', e => { e.stopPropagation(); });
        
        this.UI.buttons.bitrate.on('mouseenter', e => { this.bitrate.eventBitrate(e); });
        this.UI.buttons.bitrate.on('mouseleave', () => { this.bitrate.hidePopup(); });
        this.UI.popups.bitrate.on('mouseenter', () => { this.bitrate.showPopup(); });
        this.UI.popups.bitrate.on('mouseleave', () => { this.bitrate.hidePopup(); });
        this.UI.popups.bitrate.on('click', e => { e.stopPropagation(); });
        
        this.UI.buttons.switchNext.on('click', e => { this.eventSwitchNextChapter(e); });
        this.UI.buttons.switchPrev.on('click', e => { this.eventSwitchPrevChapter(e); });
        this.UI.buttons.fullscreen.on('click', e => { this.toggleFullscreen(e); });
        this.share.initShareEvents();
        this.sleep.initSleepEvents();
        this.bitrate.initBitrateEvents();

        setTimeout(() => {
            this.hidePlayerUI();
        }, 4000);

        this.mainWrapper.on('mousemove', () => {
            this.mainWrapper.removeClass('hide-ui');
            this.cursorMoved = true;
        });

        this.UI.album.addToFav.on('click', () => {
            if (!this.user.isVip) {
                this.channels.systemMessages.showMessage('vipFavorites');
                return;
            }

            this.UI.album.addToFav.css('opacity', .25);
            this.UI.album.addToFav.css('pointer-events', 'none');

            if (this.UI.album.addToFav.hasClass('is-favorited')) {
                this.channels.removeFromFavorites(this.currentChannel.id, () => {
                    this.UI.album.addToFav.css('opacity', '');
                    this.UI.album.addToFav.css('pointer-events', 'auto');
                });
            } else {
                this.channels.addToFavorites(this.currentChannel.id, () => {
                    this.UI.album.addToFav.css('opacity', '');
                    this.UI.album.addToFav.css('pointer-events', 'auto');
                });
            }
        });

        this.UI.album.like.on('click', () => {
            if (this.UI.album.like.hasClass('is-liked')) {
                return;
            }

            this.cover.likeTrack();
        });

        this.UI.album.dislike.on('click', () => {
            if (this.UI.album.dislike.hasClass('is-disliked')) {
                return;
            }

            this.cover.dislikeTrack();
        });

        $(window).unload(() => {
            if (!this.user.isVip) {
                this.freePlayback.freePlaybackNotification(false, true);
            }
        });

        this.wrapper.on('click', e => {
            if ($(e.target).hasClass('channel-chapters-item-link')) {
                e.preventDefault();
                let startTime = parseInt($(e.target).attr('data-start'), 10);
                let channelID = parseInt($(e.target).attr('data-channel-id'), 10);
                this.loadChannel(channelID, true, false, startTime);
                this.updateChaptersUI(startTime);
            }

            let dropdown = this.wrapper.find('.channel-chapters-list-wrapper');

            if ($(e.target).hasClass('channel-chapters-current-item')) {
                e.stopPropagation();
                dropdown.toggleClass('is-closed');

                if (!dropdown.hasClass('is-closed')) {
                    let currentElement = dropdown.find('.is-current');
                    
                    if (currentElement.length) {
                        currentElement[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    }
                }

                return;
            }

            if (dropdown.length) {
                dropdown.addClass('is-closed');
            }
        });

        $(this.audioChannels.channel1.element).on('ended', () => {
            if (this.currentChannelHasChapters()) {
                $(document).trigger('bookPlayingEnded', [this.currentChannel.id]);
            }
        });

        $(document).on('bookPlayingEnded', (event, channelID) => {
            console.log('Book ended', channelID, this.channelCategorySupportsPlayNext(channelID));

            if (this.channelCategorySupportsPlayNext(channelID)) {
                console.log('Play next channel', channelID);
                this.playNextChannel(channelID);
            }
        });

        setTimeout(() => {
            this.wrapper.find('.cr-player-ui').addClass('is-active');
            this.wrapper.parent().find('.cr-player-external-ui').addClass('is-active');
            this.wrapper.parent().find('.cr-player-volume').addClass('is-active');
        }, 1000);
    }

    hidePlayerUI () {
        if (this.cursorMoved) {
            this.cursorMoved = false;
        } else {
            this.mainWrapper.addClass('hide-ui');
        }

        setTimeout(() => {
            this.hidePlayerUI();
        }, 4000);
    }

    eventPlay (playerIsPaused) {
        this.playing = !this.playing;
        $(document).trigger('playingStateChanged', [this.playing]);

        if (this.playing) {
            this.UI.buttons.play.addClass('is-loading');
        } else {
            $('*[data-channel-id]').removeClass('is-played');
        }

        if (this.sleepMode) {
            this.sleepMode = false;

            if (this.currentChannelHasChapters() && playerIsPaused) {
                this.resumeAudio();
            } else {
                this.playAudio();
            }
        } else {
            if (this.playing) {
                if (this.currentChannelHasChapters() && playerIsPaused) {
                    this.resumeAudio();
                } else {
                    this.playAudio();
                }
            } else {
                if (this.introTimeout) {
                    clearTimeout(this.introTimeout);
                }

                if (this.currentChannelHasChapters()) {
                    this.pauseEventToSkip = true;
                    this.audioChannels.channel1.element.pause();
                    this.channels.segmentIntegration.sendApiEvent('Audio Playback Completed', 1, 'pause');
                } else {
                    this.audioChannels.channel1.element.setAttribute('src', '');
                    this.channels.segmentIntegration.sendApiEvent('Audio Playback Completed', 1, 'pause');
                }

                this.UI.buttons.playIconPause.addClass('is-hidden');
                this.UI.buttons.playIconPlay.removeClass('is-hidden');
            }
        }
    }

    eventPause () {
        this.playing = false;
        $(document).trigger('playingStateChanged', [false]);
        $('*[data-channel-id]').removeClass('is-played');
        this.channels.segmentIntegration.sendApiEvent('Audio Playback Completed', 1, 'pause');

        if (this.introTimeout) {
            clearTimeout(this.introTimeout);
        }

        if (this.currentChannelHasChapters()) {
            this.audioChannels.channel1.element.pause();
        } else {
            this.audioChannels.channel1.element.setAttribute('src', '');
        }

        this.UI.buttons.playIconPause.addClass('is-hidden');
        this.UI.buttons.playIconPlay.removeClass('is-hidden');
    }

    eventSwitchNextChapter () {
        this.channels.segmentIntegration.sendApiEvent('Audio Playback Completed', 1, 'next chapter');
        let timetable = this.timetableCache.getTimetable(this.currentChannel.streamID, false);
        let currentChapter = this.detectChapter(timetable);
        let currentChapterIndex = timetable.tracks.findIndex(item => item.id === currentChapter);

        if (this.checkIfChapterIsLast(currentChapter, timetable)) {
            this.UI.buttons.switchNext.addClass('is-inactive');
            return false;
        } else {
            let nextChapter = timetable.tracks[currentChapterIndex + 1];
            this.audioChannels.channel1.element.currentTime = nextChapter.start;

            if (this.checkIfChapterIsLast(nextChapter.id, timetable)) {
                this.UI.buttons.switchNext.addClass('is-inactive');
            } else {
                this.UI.buttons.switchNext.removeClass('is-inactive');
            }
        }

        setTimeout(() => {
            this.debouncedSaveLastListenedChapter();
            this.cover.fastUpdateChapterData();
            this.channels.segmentIntegration.sendApiEvent('Audio Playback Started', 1, 'next chapter');
        }, 100);
    }

    eventSwitchPrevChapter () {
        this.channels.segmentIntegration.sendApiEvent('Audio Playback Completed', 1, 'prev chapter');
        let timetable = this.timetableCache.getTimetable(this.currentChannel.streamID, false)
        let currentChapter = this.detectChapter(timetable);
        let currentChapterIndex = timetable.tracks.findIndex(item => item.id === currentChapter);
        let currentChapterStartTime = timetable.tracks[currentChapterIndex].start;

        if (this.audioChannels.channel1.element.currentTime - 5 > currentChapterStartTime || currentChapterIndex === 0) {
            this.audioChannels.channel1.element.currentTime = currentChapterStartTime;
        } else {
            let prevChapter = timetable.tracks[currentChapterIndex - 1];
            this.audioChannels.channel1.element.currentTime = prevChapter.start;
        }

        if (timetable.tracks.length > 1) {
            this.UI.buttons.switchNext.removeClass('is-inactive');
        }

        setTimeout(() => {
            this.debouncedSaveLastListenedChapter();
            this.cover.fastUpdateChapterData();
            this.channels.segmentIntegration.sendApiEvent('Audio Playback Started', 1, 'prev chapter');
        }, 100);
    }

    addCommunicationEvents () {
        $(document).on('playerMakeTransparent', () => {
            this.UI.album.wrapper.addClass('is-transparent');
        });

        $(document).on('playerMakeOpaque', () => {
            this.UI.album.wrapper.removeClass('is-transparent');
        });
    }

    showLoadError () {
        this.UI.loadingError.overlay.removeClass('is-hidden');
        this.UI.loadingError.btn.on('click', e => {
            e.preventDefault();
            window.location.reload();
        });
    }

    startPlaying () {
        let lastChannels = this.remoteData.history.filter(id => id > 0);

        if (lastChannels.length > 0) {
            this.loadChannel(lastChannels[0], true, true);
        } else {
            this.loadChannel(false, true, true);
        }
    }

    isPaidChannel (channelID) {
        return this.remoteData.paidChannels.indexOf(channelID) > -1;
    }

    loadChannel (channelID = false, play = true, checkChannelFromUrl = false, startTime = false) {
        if (this.currentChannel.streamID && this.playing) {
            this.channels.segmentIntegration.sendApiEvent('Audio Playback Completed', 1, 'switch');
        }

        if (checkChannelFromUrl && this.channelFromUrl) {
            let previousChannelID = channelID;
            channelID = this.channelFromUrl;
            this.channelFromUrl = false;

            if (isNaN(channelID)) {
                channelID = previousChannelID;
            }

            let channelExists = this.remoteData.channels.filter(channel => channel.id === channelID);

            if (!channelExists.length) {
                channelID = previousChannelID;
            }
        }

        if (channelID === false) {
            this.currentChannel.id = this.remoteData.channels[0].id;
            this.currentChannel.channelName = this.remoteData.channels[0].title;

            if (this.user.isVip) {
                let vipChannelIndex = 0;

                if (this.useAlernativeVipChannel && this.remoteData.channels[0].vip[1]) {
                    vipChannelIndex = 1;
                }

                this.currentChannel.streamUrl = this.remoteData.channels[0].vip[vipChannelIndex].streams[this.bitrateMode] + '?user=' + this.user.login + '&pass=' + this.user.token;
                this.currentChannel.streamID = this.remoteData.channels[0].vip[vipChannelIndex].id;
                this.currentChannel.url = this.remoteData.channels[0].vip[vipChannelIndex].recent_tracks;
            } else {
                this.currentChannel.streamUrl = this.remoteData.channels[0].free[0].streams['128'];
                this.currentChannel.streamID = this.remoteData.channels[0].free[0].id;
                this.currentChannel.url = this.remoteData.channels[0].free[0].recent_tracks;
            }

            if (play) {
                this.playChannel();
            }
        } else {
            let channel = this.remoteData.channels.filter(channel => channel.id === channelID)[0];
            this.previousChannelID = this.currentChannel.id;
            this.currentChannel.id = channel.id;
            this.currentChannel.channelName = channel.title;

            if (this.user.isVip) {
                let vipChannelIndex = 0;

                if (this.useAlernativeVipChannel && channel.vip[1]) {
                    vipChannelIndex = 1;
                }

                this.currentChannel.streamUrl = channel.vip[vipChannelIndex].streams[this.bitrateMode] + '?user=' + this.user.login + '&pass=' + this.user.token;
                this.currentChannel.streamID = channel.vip[vipChannelIndex].id;
                this.currentChannel.url = channel.vip[vipChannelIndex].recent_tracks;
            } else {
                if (channel.free[0]) {
                    this.currentChannel.streamUrl = channel.free[0].streams['128'];
                    this.currentChannel.streamID = channel.free[0].id;
                    this.currentChannel.url = channel.free[0].recent_tracks;
                } else {
                    this.currentChannel.id = this.remoteData.channels[0].id;
                    this.currentChannel.channelName = this.remoteData.channels[0].title;
                    this.currentChannel.streamUrl = this.remoteData.channels[0].free[0].streams['128'];
                    this.currentChannel.streamID = this.remoteData.channels[0].free[0].id;
                    this.currentChannel.url = this.remoteData.channels[0].free[0].recent_tracks;

                    if (channel.free.length === 0) {
                        this.channels.systemMessages.showMessage('vipAtmos');
                    }
                }
            }

            if (play) {
                this.playChannel();
            }
        }

        this.UI.album.addToFav.attr('data-channel-id', this.currentChannel.id);
        
        setTimeout(() => {
            this.checkChannelFavoritesStatus();
            this.cover.getCurrentChannelData();
        }, 500);

        if (this.currentChannelHasChapters()) {
            let channelID = this.currentChannel.id;
            let streamID = this.remoteData.channelsToStoryMap[channelID];
            this.UI.album.info.chapters.removeClass('is-hidden');
            this.UI.album.info.title.addClass('is-hidden');
            this.currentChannel.streamID = streamID;
            this.currentChannel.streamUrl = this.remoteData.storiesStreams[streamID] + '?username=' + this.user.login + '&token=' + this.user.token;
            this.currentChannel.url = this.remoteData.storiesStreams[streamID] + '.json?username=' + this.user.login + '&token=' + this.user.token;
            this.UI.buttons.switchPrev.removeClass('is-inactive');
            this.UI.buttons.switchNext.removeClass('is-inactive');
            this.wrapper.find('.cr-player-ui').addClass('is-in-story-mode');

            let storyID = this.remoteData.channelsToStoryMap[channelID];
            let timetableCachedData = this.timetableCache.getTimetable(storyID);
            let lastListenedChapter = this.remoteData.lastListenedChapters[channelID];

            if (!lastListenedChapter) {
                lastListenedChapter = 1;
            }

            if (timetableCachedData !== false) {
                if (startTime === false) {
                    startTime = timetableCachedData.tracks[lastListenedChapter - 1].start;
                }

                let url = TC_ChannelChapters.getStoryTimetableUrl(this.remoteData, channelID);
                TC_ChannelChapters.getStoryTimetable(this.channels, url, channelID, 'player');
                this.preparePlayerUI(play, startTime);
            } else {
                let url = TC_ChannelChapters.getStoryTimetableUrl(this.remoteData, channelID);
                let timetableUrl = url + '?username=' + this.user.login + '&token=' + this.user.token;
    
                $.get({
                    url: timetableUrl,
                    dataType: 'json',
                    success: (data, status) => {
                        if (!(status === 'success' && data)) {
                            return;
                        }
            
                        this.timetableCache.saveTimetable(storyID, data);

                        if (startTime === false) {
                            startTime = data.tracks[lastListenedChapter - 1].start;
                        }

                        TC_ChannelChapters.getStoryTimetable(this.channels, url, channelID, 'player');
                        this.preparePlayerUI(play, startTime);
                    }
                });
            }
        } else {
            this.UI.album.info.chapters.addClass('is-hidden');
            this.UI.album.info.title.removeClass('is-hidden');
            this.wrapper.find('.cr-player-ui').removeClass('is-in-story-mode');
            this.UI.buttons.switchPrev.addClass('is-inactive');
            this.UI.buttons.switchNext.addClass('is-inactive');
            this.preparePlayerUI(play, startTime);    
        }
    }

    preparePlayerUI (play, startTime) {
        this.bitrate.toggleBitrateUI();
        this.togglePrevNextTitles();

        if (play) {
            this.playChannel(startTime);
        }

        this.UI.album.addToFav.attr('data-channel-id', this.currentChannel.id);
        this.checkChannelFavoritesStatus();
        this.cover.getCurrentChannelData();
    }

    checkChannelFavoritesStatus () {
        if (this.channels.isInFavorites(this.currentChannel.id)) {
            this.UI.album.addToFav.addClass('is-favorited');
        } else if (this.UI && this.UI.album && this.UI.album.addToFav) {
            this.UI.album.addToFav.removeClass('is-favorited');
        }
    }

    playChannel (startTime = false) {
        this.playing = true;
        $(document).trigger('playingStateChanged', [this.playing]);
        this.playAudio(true, startTime);
    }

    playAudio (switchedChannel = false, startTime = false) {
        this.UI.buttons.play.addClass('is-loading');
        this.UI.buttons.playIconPause.removeClass('is-hidden');
        this.UI.buttons.playIconPlay.addClass('is-hidden');

        $(this.audioChannels.channel1.element).one('canplay', () => {
            let promise = this.audioChannels.channel1.element.play();

            if (startTime !== false) {
                this.audioChannels.channel1.element.currentTime = startTime;
            }

            if (promise !== undefined) {
                promise.then(_ => {
                    if (this.mutedAutoplay) {
                        this.mutedAutoplay = false;
                        this.UI.buttons.play.removeClass('is-loading');
                        this.UI.buttons.playIconPause.addClass('is-hidden');
                        this.UI.buttons.playIconPlay.removeClass('is-hidden');
                        this.playing = false;
                        $(document).trigger('playingStateChanged', [this.playing]);
                    } else {
                        this.UI.buttons.play.removeClass('is-loading');
                        this.audioVolumeIntro();
                        $('*[data-channel-id]').removeClass('is-played');
                        $('*[data-channel-id="' + this.currentChannel.id + '"]').addClass('is-played');

                        if (this.currentChannelHasChapters()) {
                            return this.debouncedSaveLastListenedChapter();
                        }
                    }
                }).catch(error => {
                    this.mutedAutoplay = false;
                    this.UI.buttons.play.removeClass('is-loading');
                    this.UI.buttons.playIconPause.addClass('is-hidden');
                    this.UI.buttons.playIconPlay.removeClass('is-hidden');
                    this.playing = false;
                    $(document).trigger('playingStateChanged', [this.playing]);
                });
            } else {
                this.UI.buttons.play.removeClass('is-loading');
                this.audioVolumeIntro();
                $('*[data-channel-id]').removeClass('is-played');
                $('*[data-channel-id="' + this.currentChannel.id + '"]').addClass('is-played');

                if (this.currentChannelHasChapters()) {
                    return this.debouncedSaveLastListenedChapter();
                }
            }
        });

        $(this.audioChannels.channel1.element).attr('src', this.currentChannel.streamUrl);

        if (!this.user.isVip) {
            this.freePlayback.freePlaybackNotification(switchedChannel);
        } else {
            if (switchedChannel) {
                setTimeout(() => {
                    $(document).trigger('playerSessionSaved');
                }, 500);
            }
        }
    }

    resumeAudio () {
        this.audioChannels.channel1.element.play();
        this.UI.buttons.play.removeClass('is-loading');
        this.UI.buttons.playIconPause.removeClass('is-hidden');
        this.UI.buttons.playIconPlay.addClass('is-hidden');
        $('*[data-channel-id]').removeClass('is-played');
        $('*[data-channel-id="' + this.currentChannel.id + '"]').addClass('is-played');
    }

    audioVolumeIntro (prevVolume = 0) {
        prevVolume += .03125;
        this.audioChannels.channel1.element.volume = prevVolume;

        if (prevVolume < this.audioChannels.channel1.volume) {
            this.introTimeout = setTimeout(() => {
                this.audioVolumeIntro(prevVolume);
            }, 100);
        }
    }

    audioVolumeOutro (prevVolume = 1) {
        prevVolume -= .03125;
        this.audioChannels.channel1.element.volume = prevVolume;

        if (prevVolume > 0) {
            setTimeout(() => {
                this.audioVolumeOutro(prevVolume);
            }, 100);
        } else {
            this.playing = false;
            $(document).trigger('playingStateChanged', [this.playing]);

            if (this.currentChannelHasChapters()) {
                this.pauseEventToSkip = true;
                this.audioChannels.channel1.element.pause();
                this.channels.segmentIntegration.sendApiEvent('Audio Playback Completed', 1, 'pause');
            } else {
                this.audioChannels.channel1.element.setAttribute('src', '');
                this.channels.segmentIntegration.sendApiEvent('Audio Playback Completed', 1, 'pause');
            }

            this.audioChannels.channel1.element.setAttribute('src', '');
            this.UI.buttons.playIconPause.addClass('is-hidden');
            this.UI.buttons.playIconPlay.removeClass('is-hidden');
        }
    }

    initBugSnagReporting () {
        this.audioChannels.channel1.element.addEventListener('error', () => { this.sendBugSnagReport(this.audioChannels.channel1.element, 1); }, false);
    }

    sendBugSnagReport (audioElement, channel) {
        /*
        jQuery.ajax({
            url: 'https://notify.bugsnag.com/',
            method: 'POST',
            contentType:"application/json; charset=utf-8",
            dataType:"json",
            data: JSON.stringify({
                apiKey: '',
                notifier: {
                    name: 'CalmChristian Production',
                    version: '1.0.0',
                    url: window.location.href
                },
                events: [{
                  "payloadVersion": "5",
                  "exceptions": [
                    {
                      "errorClass": "PlaybackError",
                      "message": "Unable to connect to to the streaming server",
                      "stacktrace": [
                        {
                          "file": audioElement.getAttribute('src').split('?')[0],
                          "lineNumber": 0,
                          "columnNumber": 0,
                          "method": "get",
                          "inProject": true
                        }
                      ]
                    }
                  ],
                  context: 'Channel in multimixer #' + channel,
                  user: {
                     id: parseInt($('.cr-player').attr('data-user-id'), 10)
                  }
               }]
            })
        });
        */
    }

    currentChannelHasChapters () {
        return this.remoteData.channelsWithStories.indexOf(this.currentChannel.id) > -1;
    }

    detectChapter (chaptersData) {
        let currentTime = this.audioChannels['channel1'].element.currentTime;
        let tracks = chaptersData.tracks.slice();
        let currentTrackID = false;
        tracks = tracks.filter(track => track.start <= currentTime);
        let lastTrack = tracks.pop();
        currentTrackID = lastTrack.id;

        return currentTrackID;
    }

    checkIfChapterIsFirst (chapterTrackID, chaptersData) {
        if (chaptersData.tracks[0].id === chapterTrackID) {
            return true;
        }

        return false;
    }

    checkIfChapterIsLast (chapterTrackID, chaptersData) {
        let lastIndex = chaptersData.tracks.length - 1;

        if (chaptersData.tracks[lastIndex].id === chapterTrackID) {
            return true;
        }

        return false;
    }

    detectChapterIndex (chaptersData) {
        let currentTime = this.audioChannels['channel1'].element.currentTime;
        let tracks = chaptersData.tracks.slice();
        let currentTrackID = false;
        tracks = tracks.filter(track => track.start <= currentTime);
        let lastTrack = tracks.pop();
        currentTrackID = lastTrack.id;
        let currentTrackIndex = chaptersData.tracks.findIndex(item => item.id === currentTrackID);

        return currentTrackIndex;
    }

    updateExpandedItemsUI (channelID, chapterNumber) {
        let expandedWrapper = $('.calmchristian-channels-expanded[data-expanded-channel="' + parseInt(channelID, 10) + '"]');

        if (expandedWrapper.length) {
            expandedWrapper.find('.channel-chapters-item').removeClass('is-current');
            let currentItem = expandedWrapper.find('.channel-chapters-item[data-chapter-number="' + parseInt(chapterNumber, 10) + '"]');
            currentItem.eq(0).addClass('is-current');
            expandedWrapper.find('.channel-chapters-current-item').text(currentItem.eq(0).text());
        }
    }

    updateChaptersUI (startTime, chapterNumber = false) {
        this.UI.album.info.chapters.find('.channel-chapters-item').removeClass('is-current');
        let currentItem;

        if (chapterNumber) {
            currentItem = this.UI.album.info.chapters.find('.channel-chapters-item[data-chapter-number="' + parseInt(chapterNumber, 10) + '"] .channel-chapters-item-link');
        } else {
            currentItem = this.UI.album.info.chapters.find('.channel-chapters-item-link[data-start="' + parseInt(startTime, 10) + '"]');
        }
        
        currentItem.eq(0).parent().addClass('is-current');
        this.UI.album.info.chapters.find('.channel-chapters-current-item').text(currentItem.eq(0).text());
    }

    initSeekingBarEvents () {
        $(document).on('seekingBarUpdate', e => {
            if (!this.currentChannelHasChapters()) {
                return; 
            }

            let progress = Number(this.getProgressOfCurrentChapter()).toFixed(4) + '%';
            this.UI.seekingBar.progressBar.css('width', progress);
        });

        this.UI.seekingBar.bar.on('click', e => {
            if (!this.currentChannelHasChapters()) {
                return;
            }

            let newProgress = e.offsetX / this.UI.seekingBar.bar.width();
            this.UI.seekingBar.progressBar.css('width', (newProgress * 100) + '%');
            this.setNewCurrentTime(newProgress);
        });
    }

    getProgressOfCurrentChapter () {
        let timetable = this.timetableCache.getTimetable(this.currentChannel.streamID, false);
        let currentTime = this.audioChannels.channel1.element.currentTime;

        if (!timetable.tracks) {
            return;
        }

        let pastChapters = timetable.tracks.filter(track => track.start <= currentTime);
        let chapter = timetable.tracks[pastChapters.length - 1];
        let startPoint = chapter.start;
        let endPoint = this.audioChannels.channel1.element.duration;
        let nextChapter = timetable.tracks[pastChapters.length];

        if (nextChapter) {
            endPoint = nextChapter.start;
        }

        let progress = (currentTime - startPoint) / (endPoint - startPoint);
        return progress * 100;
    }

    setNewCurrentTime (progress) {
        let timetable = this.timetableCache.getTimetable(this.currentChannel.streamID, false);
        let currentTime = this.audioChannels.channel1.element.currentTime;
        let pastChapters = timetable.tracks.filter(track => track.start <= currentTime);
        let chapter = timetable.tracks[pastChapters.length - 1];
        let startPoint = chapter.start;
        let endPoint = this.audioChannels.channel1.element.duration;
        let nextChapter = timetable.tracks[pastChapters.length];

        if (nextChapter) {
            endPoint = nextChapter.start;
        }

        let newCurrentTime = ((endPoint - startPoint) * progress) + startPoint;
        this.audioChannels.channel1.element.currentTime = newCurrentTime;
    }

    togglePrevNextTitles () {
        if (this.currentChannelHasChapters()) {
            this.UI.buttons.switchPrev.attr('title', this.UI.buttons.switchPrev.attr('data-text-story'));
            this.UI.buttons.switchNext.attr('title', this.UI.buttons.switchNext.attr('data-text-story'));
        } else {
            this.UI.buttons.switchPrev.attr('title', this.UI.buttons.switchPrev.attr('data-text-alt'));
            this.UI.buttons.switchNext.attr('title', this.UI.buttons.switchNext.attr('data-text-alt'));
        }
    }

    toggleFullscreen (e) {
        e.preventDefault();

        if (document.fullscreenElement) {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) { 
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        } else {
            if (document.body.requestFullscreen) {
                document.body.requestFullscreen();
            } else if (document.body.mozRequestFullScreen) {
                document.body.mozRequestFullScreen();
            } else if (document.body.webkitRequestFullscreen) {
                document.body.webkitRequestFullscreen();
            } else if (document.body.msRequestFullscreen) {
                document.body.msRequestFullscreen();
            }
        }
    }

    channelCategorySupportsPlayNext (channelID) {
        let foundedCategory = this.remoteData.categories.filter(category => category.channels.indexOf(channelID) > -1);

        if (foundedCategory[0] && foundedCategory[0].post_play) {
            return true;
        }

        return false;
    }

    playNextChannel (channelID) {
        let foundedCategory = this.remoteData.categories.filter(category => category.channels.indexOf(channelID) > -1);

        if (foundedCategory[0]) {
            let indexInChannelsList = foundedCategory[0].channels.indexOf(channelID);

            if (indexInChannelsList < foundedCategory[0].channels.length - 1) {
                let nextChannelID = parseInt(foundedCategory[0].channels[indexInChannelsList + 1], 10);
                this.loadChannel(nextChannelID, true, false, 0);
            }
        }
    }

    getChannelFromUrl () {
        let query = window.location.search.substring(1);
        let queryParams = query.split('&');
        
        for (let i = 0; i < queryParams.length; i++) {
            let keyPair = queryParams[i].split('=');

            if (decodeURIComponent(keyPair[0]) === 'channel') {
                let  channel = decodeURIComponent(keyPair[1]);

                if (channel) {
                    return parseInt(channel, 10);
                }

                break;
            }
        }

        return false;
    }
}
